<div class="table">
    <nz-table #basicTable [nzData]="listOfData" [nzScroll]="{ x: nzScrollWidth }" [nzShowSizeChanger]="false"
        [nzTotal]="totalRecords" [nzPageSize]="pageSize" [nzPageIndex]="currentPage"
        (nzPageIndexChange)="onPageChange($event)" nzTableLayout="fixed" [nzShowPagination]="isPagination"
        [nzFrontPagination]="false">
        <thead>
            <tr>
                <th *ngFor="let column of columns" [nzWidth]="column.width">{{ column.name | translate }}</th>
                <th *ngIf="showAction">
                    {{ 'table.action' | translate }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let data of basicTable.data">
                <td *ngFor="let column of columns">{{ data[column.key] }}</td>

                <td *ngIf="showAction">
                    <span class="view-icon" *ngIf="iconType === 'arrow'">
                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.5 7L6.5 18" stroke="#2E3B55" stroke-width="1.5" stroke-linecap="round" />
                            <path
                                d="M11.5 6.13153C11.5 6.13153 17.1335 5.65664 17.9885 6.51155C18.8434 7.36647 18.3684 13 18.3684 13"
                                stroke="#2E3B55" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </span>
                    <span class="view-icon" *ngIf="iconType === 'menu'">
                        <div class="dropdown">
                            <a class="btn dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown"
                                aria-expanded="false">
                                <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52"
                                    fill="none">
                                    <rect x="0.969238" y="0.538452" width="50.4769" height="50.4769" rx="25.2385"
                                        fill="#F5F5F9" />
                                    <circle cx="26.2077" cy="16.8693" r="2.96923" fill="#ABB1BB" />
                                    <circle cx="26.2075" cy="25.7768" r="2.96923" fill="#ABB1BB" />
                                    <circle cx="26.2075" cy="34.6846" r="2.96923" fill="#ABB1BB" />
                                </svg>
                            </a>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" href="#">Action</a></li>
                                <li><a class="dropdown-item" href="#">Another action</a></li>
                                <li><a class="dropdown-item" href="#">Something else here</a></li>
                            </ul>
                        </div>
                    </span>
                </td>
            </tr>
        </tbody>
    </nz-table>
</div>